// ============================================
// MODALIDADE DE ATENDIMENTO — fonte única (B351, AI_152)
// ============================================
// `paciente.tipoAtendimento` é `string` LIVRE, não enum, e é lido por ~30 arquivos.
// O compilador não ajuda: cada `=== "figado"` espalhado pelo código decide, em
// silêncio, se a modalidade nova entra ou fica de fora — às vezes certo, às vezes
// errado. Este módulo existe para que a decisão seja NOMEADA e pesquisável, em vez
// de literal solto.
//
// ⚠️ Ao ligar uma modalidade nova, percorrer os consumidores e decidir CADA UM.
//    O mapa dos pontos está no item B351 do backlog.

/** Doador vivo de fígado (transplante intervivos). */
export const DOADOR_FIGADO = "doador_figado";

/** Receptor de fígado (a modalidade que já existia). */
export const FIGADO = "figado";

/**
 * O paciente é um DOADOR vivo de fígado?
 *
 * Importa porque quase tudo que o prontuário do receptor faz — MELD, Child,
 * situação especial, alertas de hipertensão portal — não se aplica a um doador
 * saudável, e porque a pergunta clínica dele é outra: não é "este fígado está
 * falindo?", é "este fígado pode ser dividido com segurança?".
 */
export function ehDoadorFigado(tipoAtendimento?: string | null): boolean {
  return (tipoAtendimento || "").trim().toLowerCase() === DOADOR_FIGADO;
}

/**
 * O prontuário é de fígado em QUALQUER papel (receptor ou doador)?
 *
 * Use quando a pergunta for "é hepatologia/cirurgia hepática?" — por exemplo para
 * decidir se o corpus de diretrizes hepáticas é pertinente. NÃO use para liberar
 * campo de receptor (MELD/Child): para isso a pergunta é `=== FIGADO`.
 */
export function ehLinhaFigado(tipoAtendimento?: string | null): boolean {
  const t = (tipoAtendimento || "").trim().toLowerCase();
  return t === FIGADO || t === DOADOR_FIGADO;
}

/** Rótulo curto para telas e selos. */
export function rotuloModalidade(tipoAtendimento?: string | null): string {
  switch ((tipoAtendimento || "").trim().toLowerCase()) {
    case FIGADO:
      return "Fígado";
    case DOADOR_FIGADO:
      return "Doador de Fígado";
    case "rim":
      return "Rim";
    case "pancreas":
    case "pancreas_rim":
    case "rim_pancreas":
      return "Pâncreas";
    case "ambulatorial":
      return "Ambulatorial";
    default:
      return tipoAtendimento || "";
  }
}
